export class ContactUsEmailModelNames {
    public static type: string = 'type';
    public static subject: string = 'subject';
    public static senderName: string = 'senderName';
    public static senderEmail: string = 'senderEmail';
    public static body: string = 'body';
}

export class ContactUsEmailModelBase {
    type: string = '';
    subject: string = '';
    senderName: string = '';
    senderEmail: string = '';
    body: string = '';
}
